// ── Quiz Player Controller ────────────────────────────────────────────────────
// Props:
//   question       : string | null
//   options        : string[]
//   selectedAnswer : number | null
//   result         : { correct: number } | null
//   onAnswer       : (index: number) => void

const OPTION_COLORS = [
  "bg-[#FF0055] hover:bg-[#FF3377]",
  "bg-[#00AAFF] hover:bg-[#33BBFF]",
  "bg-[#39FF14] hover:bg-[#66FF44]",
  "bg-[#FFFF00] hover:bg-[#FFFF44]",
];
const OPTION_LABELS = ["A", "B", "C", "D"];

export default function QuizPlayer({ question, options, selectedAnswer, result, onAnswer }) {
  if (!question) {
    return (
      <div className="flex-1 flex items-center justify-center">
        <div className="w-12 h-12 border-4 border-[#FF00FF] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="flex-1 flex flex-col animate-slide-up">
      <div className="mb-4 text-center">
        <p className="text-[#A1A1AA] text-sm mb-2">ВОПРОС</p>
        <h2 className="font-heading text-lg text-white leading-tight">{question}</h2>
      </div>

      <div className="flex-1 grid grid-cols-2 gap-3">
        {options.map((option, i) => {
          const isSelected = selectedAnswer === i;
          const isCorrect = result && result.correct === i;
          const isWrong = result && selectedAnswer === i && result.correct !== i;

          return (
            <button
              key={i}
              onClick={() => onAnswer(i)}
              disabled={selectedAnswer !== null}
              data-testid={`quiz-answer-${i}`}
              className={`
                ${OPTION_COLORS[i]}
                rounded-2xl p-4
                flex flex-col items-center justify-center
                transition-all active:scale-95
                ${isSelected ? "ring-4 ring-white" : ""}
                ${isCorrect ? "ring-4 ring-[#39FF14] animate-bounce-in" : ""}
                ${isWrong ? "opacity-50 animate-shake" : ""}
                ${selectedAnswer !== null && !isSelected ? "opacity-50" : ""}
              `}
            >
              <span className="font-display text-3xl text-black mb-1">{OPTION_LABELS[i]}</span>
              <span className="font-bold text-black text-center text-sm leading-tight">{option}</span>
            </button>
          );
        })}
      </div>

      {result && (
        <div className="mt-4 text-center animate-bounce-in">
          <p className={`font-heading text-xl ${selectedAnswer === result.correct ? "text-[#39FF14]" : "text-[#FF0055]"}`}>
            {selectedAnswer === result.correct ? "+100 очков!" : "Неправильно"}
          </p>
        </div>
      )}
    </div>
  );
}
